var map = {
	"./blue/background-2.png": "665c",
	"./bm/background-2.png": "feac",
	"./iom/background-2.png": "4044",
	"./mavir-orange/background-2.png": "8c49",
	"./mavir/background-2.png": "cbcb",
	"./minerva/background-2.png": "90b1",
	"./mvm/background-2.png": "c02c",
	"./neting/background-2.png": "ab04",
	"./red/background-2.png": "9855",
	"./skillgo/background-2.png": "22c9",
	"./unhcr/background-2.png": "a733"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a69";